var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDisabledCheckbox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2609 0.181641C17.5893 0.181641 19.818 2.51837 19.818 5.994V14.0164C19.818 17.4813 17.5893 19.818 14.2609 19.818H5.74855C2.42019 19.818 0.181641 17.4813 0.181641 14.0164V5.994C0.181641 2.51837 2.42019 0.181641 5.74855 0.181641H14.2609ZM14.1038 7.05437C13.77 6.72055 13.2202 6.72055 12.8864 7.05437L8.83146 11.1093L7.11328 9.3911C6.77946 9.05728 6.22964 9.05728 5.89582 9.3911C5.562 9.72491 5.562 10.2649 5.89582 10.6086L8.23255 12.9355C8.39946 13.1024 8.61546 13.1809 8.83146 13.1809C9.05728 13.1809 9.27328 13.1024 9.44019 12.9355L14.1038 8.27182C14.4376 7.938 14.4376 7.398 14.1038 7.05437Z",
    fill: "#999999"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledCheckbox);
export default __webpack_public_path__ + "static/media/disabled-checkbox.d5655a83362091a156cab14c75ca833c.svg";
export { ForwardRef as ReactComponent };